<template>
  <el-dialog :title="$t('indexMenu.addShop.title')" :visible.sync="visible" width="50%" @close="handleClose">
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
      <el-form-item :label="$t('indexMenu.form.name')" prop="name">
        <el-input v-model="formData.name" :placeholder="$t('indexMenu.form.namePlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('indexMenu.form.logo')" prop="menuIcon">
        <upload-image-url ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleImageChange" />
      </el-form-item>

      <el-form-item :label="$t('indexMenu.form.product')" prop="productId">
        <el-select v-model="formData.productId" style="width:100%"
          :placeholder="$t('indexMenu.form.productPlaceholder')">
          <el-option v-for="item in products" :key="item.productId" :label="item.prodName" :value="item.productId" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('indexMenu.form.seq')" prop="seq">
        <el-input v-model="formData.seq" :placeholder="$t('indexMenu.form.seqPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('indexMenu.form.isShow')" prop="isShow">
        <el-select v-model="formData.isShow" style="width:100%" :placeholder="$t('indexMenu.form.isShowPlaceholder')">
          <el-option v-for="item in isShowOptions" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveShopMenu } from '@/api/phone/indexMenuApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryProduct } from '@/api/goods/productApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'

export default {
  name: 'AddShopMenu',
  components: {
    UploadImageUrl
  },
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        name: '',
        menuIcon: '',
        productId: '',
        seq: '',
        isShow: '',
        skipType: '2',
        shopId: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('indexMenu.validate.nameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('indexMenu.validate.nameMaxLength'), trigger: 'blur' }
        ],
        menuIcon: [
          { required: true, message: this.$t('indexMenu.validate.logoRequired'), trigger: 'change' }
        ],
        productId: [
          { required: true, message: this.$t('indexMenu.validate.productRequired'), trigger: 'change' }
        ],
        seq: [
          { required: true, message: this.$t('indexMenu.validate.seqRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('indexMenu.validate.seqNumber'), trigger: 'blur', transform: value => Number(value) }
        ],
        isShow: [
          { required: true, message: this.$t('indexMenu.validate.isShowRequired'), trigger: 'change' }
        ]
      },
      isShowOptions: [],
      products: [],
      shopId: ''
    }
  },
  methods: {
    open() {
      this.shopId = getShopId()
      this.getDictData()
      this.getProducts()
      this.visible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.$refs.uploadImage && this.$refs.uploadImage.clearImages()
      })
    },
    async getDictData() {
      try {
        const data = await getDict('housekeeping_type', 'is_show')
        this.isShowOptions = data.data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async getProducts() {
      try {
        const params = {
          page: 1,
          row: 100,
          shopId: this.shopId
        }
        const { data } = await queryProduct(params)
        this.products = data
      } catch (error) {
        console.error('获取商品列表失败:', error)
      }
    },
    handleImageChange(images) {
      if (images && images.length > 0) {
        this.formData.menuIcon = images[0]
      } else {
        this.formData.menuIcon = ''
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        try {
          this.loading = true
          this.formData.shopId = this.shopId
          this.formData.pageUrl = `/pages/goods/goods?shopId=${this.shopId}&productId=${this.formData.productId}`
          await saveShopMenu(this.formData)
          this.$message.success(this.$t('indexMenu.addShop.success'))
          this.$emit('success')
          this.visible = false
        } catch (error) {
          this.$message.error(this.$t('indexMenu.addShop.error'))
        } finally {
          this.loading = false
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>